import type { CSSProperties } from 'react';
import { getEnv } from '@/utils/env';

export const sentryDSN = getEnv('VITE_SENTRY_DSN');
export const reCAPTCHA = getEnv('VITE_RECAPTCHA_ENTERPRISE_KEY');

export const RecaptchaBranding = ({ style }: { style?: CSSProperties }) => (
  <span style={style}>
    This site is protected by reCAPTCHA and the Google
    <a href="https://policies.google.com/privacy">Privacy Policy</a> and
    <a href="https://policies.google.com/terms">Terms of Service</a> apply.
  </span>
);
